export const IMPERSONATION_LOADER = { height: '32px', width: '64px' };
